import { Box } from '@mui/material'
import React, { useState } from 'react'
import {  Container, Row } from 'react-bootstrap'

import Accordion from 'react-bootstrap/Accordion';
import { Link } from 'react-router-dom';

import axios from 'axios';

export const Footer = ({navhide}) => {


    // NewLetter validation
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    // Handle email input change
    const handleInputChange = (e) => {
        setEmail(e.target.value);
    };
    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();

        // Simple email validation
        const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!emailPattern.test(email)) {
        setError('Please enter a valid email address');

        // Clear error message after 3 seconds
        setTimeout(() => {
            setError('');
        }, 3000);
        
        return;
        }


        try {
            const response = await axios.post('http://10.20.20.123:8001/api/mail', {email});


            console.log('API response:', response.data);

            setSuccessMessage('You have successfully subscribed!');
            setEmail('');
            setError('');

            setTimeout(() => setSuccessMessage(''), 3000);
        } catch (err) {
            console.error('Subscription failed:', err);
            setError('Subscription failed. Please try again later.');
            setTimeout(() => setError(''), 3000);
        }

    };


    // Move to top
    const [visible, setVisible] = useState(false) 
    const toggleVisible = () => { 
        const scrolled = document.documentElement.scrollTop; 
        if (scrolled > 400){ 
        setVisible(true) 
        }  
        else if (scrolled <= 400){ 
        setVisible(false) 
        } 
    }; 
  
    const scrollToTop = () =>{ 
        window.scrollTo({ 
        top: 0,  
        behavior: 'smooth'
        }); 
    }; 
  
    window.addEventListener('scroll', toggleVisible); 


  return (
    <>
        <section className='subscribe-area position-relative'>
            <div className='sub-bg'>
                <img src="../assets/images/sub-bg.svg" alt="" />
            </div>
            <Container className='position-relative'>
                <div className='newsletter-1'>
                    <img src="../assets/images/newsletter-1.svg" alt="" />
                </div>
                <div className='newsletter-2'>
                    <img src="../assets/images/news-logo.svg" alt="" />
                </div>
                <div className='subscribe-padding'>
                    <Row className='align-items-center'>
                        <div className='col-lg-6'>
                            <div className='subscribe-text mb-lg-0 mb-20' data-aos="fade-right" data-aos-duration="1800">
                                <h3 className='line-2-dot'>Subscribe to the IMUII Newsletter</h3>
                                <p className='line-1-dot'>for our latest news & Insights</p>
                            </div>
                        </div>
                        <div className='col-lg-6'>
                            <form onSubmit={handleSubmit}>
                                <div className="position-relative" data-aos="fade-left" data-aos-duration="1800">
                                    <div className="single-input">
                                        <input type="email" name="email" id="email" className="form--control" value={email} onChange={handleInputChange} placeholder="Type Your Email" />
                                        <img src="../assets/images/mail.svg" alt="mail" />
                                    </div>
                                    
                                    <div className='sub-msg'>
                                        {error && <div style={{ color: '#ffff', fontSize: '14px', marginTop: '0px' }}>{error}</div>}
                                    </div>
                                    
                                    <div  className='newsletter-position'>
                                        <button className="newsletter-btn" type="submit">
                                            <span className="button-content d-flex align-items-center justify-content-center">Subscribe
                                            <img className='red-img' src="../assets/images/red-arro.svg" alt="" />
                                            <img className='white-img' src="../assets/images/white-arro.svg" alt="" /></span>
                                        </button>
                                    </div>

                                    <div className='sub-msg'>

                                        {successMessage && (
                                            <div style={{ color: '#fff', fontSize: '14px', marginTop: '0px' }}>
                                                {successMessage}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </form>
                        </div>
                    </Row>
                </div>
            </Container>
        </section>
    
        <footer className='footer_section' ref={navhide}>
            <div className='copy-1'>
                <img src="../assets/images/copy-1.svg" alt="" />
            </div>
            <div className='copy-2'>
                <img src="../assets/images/copy-2.svg" alt="" />
            </div>
            <div className='copy-3'>
                <img src="../assets/images/copy-3.svg" alt="" />
            </div>
            <div className='copy-4'>
                <img src="../assets/images/copy-4.svg" alt="" />
            </div>
            <div className='copy-5'>
                <img src="../assets/images/copy-5.svg" alt="" />
            </div>
            <div className='copy-6'>
                <img src="../assets/images/copy-6.svg" alt="" />
            </div>
            <div className='copy-7'>
                <img src="../assets/images/copy-7.svg" alt="" />
            </div>
            <div className='copy-8'>
                <img src="../assets/images/copy-8.svg" alt="" />
            </div>
            <div className='copy-9'>
                <img src="../assets/images/copy-9.svg" alt="" />
            </div>
            <div className='copy-10'>
                <img src="../assets/images/copy-10.svg" alt="" />
            </div>
            <div className='copy-11'>
                <img src="../assets/images/copy-11.svg" alt="" />
            </div>
            <div className='copy-12'>
                <img src="../assets/images/copy-12.svg" alt="" />
            </div>
            <div className='copy-13'>
                <img src="../assets/images/copy-13.svg" alt="" />
            </div>
            <div className='copy-14'>
                <img src="../assets/images/copy-14.svg" alt="" />
            </div>
            <div className='copy-15'>
                <img src="../assets/images/copy-5.svg" alt="" />
            </div>
            <div className='copy-16'>
                <img src="../assets/images/copy-4.svg" alt="" />
            </div>
            <Container>
                <Box className='d-md-block d-none'>
                    <Row>
                        <div className='col-lg-3 col-md-6 foot-margin'>
                            <div className='foorter-title'>
                                <Link className='footer-logo' to="/">
                                    <img src="../assets/images/logo.svg" alt="" />
                                </Link>
                                <div className='footer-descrip'>
                                    <p>IMUII is a full-stack IT solutions company delivering scalable, innovative digital products. From web and mobile apps to cloud and UI/UX, we turn ideas into impactful technology. </p>
                                </div>
                                <Box sx={{
                                    display: "flex",
                                    alignItems: "center"
                                }}>
                                    <Link to="https://www.facebook.com/" target='_blank' rel="noopener noreferrer">
                                        <div className='icon_footer'>
                                            <img className='facebook-1' src="../assets/images/red-facebook.svg" alt="" />
                                            <img className='facebook-2' src="../assets/images/white-facebook.svg" alt="" />
                                        </div>
                                    </Link>
                                    <Link to="https://www.instagram.com/" target='_blank' rel="noopener noreferrer">
                                        <div className='icon_footer'>
                                            <img className='insta-1' src="../assets/images/red-insta.svg" alt="" />
                                            <img className='insta-2' src="../assets/images/white-insta.svg" alt="" />
                                        </div>
                                    </Link>
                                    <Link to="https://in.linkedin.com/" target='_blank' rel="noopener noreferrer"> 
                                        <div className='icon_footer'>
                                            <img className='linkedin-1' src="../assets/images/red-linkedin.svg" alt="" />
                                            <img className='linkedin-2' src="../assets/images/white-linkedin.svg" alt="" />
                                        </div>
                                    </Link>
                                    <Link to="https://x.com/i/flow/login" target='_blank' rel="noopener noreferrer">
                                        <div className='icon_footer'>
                                            <img className='twitter-1' src="../assets/images/red-twitter.svg" alt="" />
                                            <img className='twitter-2' src="../assets/images/white-twitter.svg" alt="" />
                                        </div>
                                    </Link>
                                </Box>
                            </div>
                        </div>

                        <div className='col-lg-3 col-md-6 foot-margin'>
                            <div className='foorter-title'>
                                <h3>Why IMUII</h3>

                                <ul>
                                    <li>
                                        <Link to='/about' className='footer-text' >About Us</Link>
                                    </li>
                                    {/* <li>
                                        <Link to='/gdpr' className='footer-text' >GDPR</Link>
                                    </li> */}
                                    <li>
                                        <Link to='/career' className='footer-text' >Career</Link>
                                    </li>
                                    {/* <li>
                                        <Link to='/on-demand-developers' className='footer-text' >On Demand Developers</Link>
                                    </li> */}
                                    <li>
                                        <Link to='/contact' className='footer-text' >Contact Us</Link>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div className='col-lg-3 col-md-6'>
                            <div className='foorter-title'>
                                <h3>Services</h3>

                                <ul>
                                    <li>
                                        <Link to='/web-development' className='footer-text' >Web Development</Link>
                                    </li>
                                    <li>
                                        <Link to='/eCommerce-development' className='footer-text' >E-commerce Development</Link>
                                    </li>
                                    <li>
                                        <Link to='/mobile-application-development' className='footer-text' >Mobile Application Development</Link>
                                    </li>
                                    <li>
                                        <Link to='/saas-development' className='footer-text' >SAAS Development</Link>
                                    </li>
                                    <li>
                                        <Link to='/cybersecurity' className='footer-text' >Cybersecurity</Link>
                                    </li>
                                    
                                    <li>
                                        <Link to='/it-infrastructure' className='footer-text' >IT Infrastructure</Link>
                                    </li>
                                    <li>
                                        <Link to='/information-database-security' className='footer-text' >Information Database Security</Link>
                                    </li>
                                    <li>
                                        <Link to='/artificial-intelligence' className='footer-text' >Artificial Intelligence</Link>
                                    </li>
                                    <li>
                                        <Link to='/end-to-end' className='footer-text' >End-to-End Business Solutions</Link>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div className='col-lg-3 col-md-6'>
                            <div className='foorter-title'>
                                <h3>Contact Us</h3>

                                <div className='footer-address'>
                                    <p className='office-text'><strong>HEAD OFFICE :</strong> <br /> 616, Anna Salai, Thousand Lights, Chennai, Tamil Nadu 600006.</p>
                                    <p>Sales : +91 444 777 4011 <br /> Support : +91 444 777 4011</p>
                                </div>
                            </div>
                        </div>
                    </Row>
                </Box>

                <Box className='d-md-none d-block'>
                    <div className='foorter-title mb-15'>
                        <div className='footer-logo'>
                            <img src="../assets/images/logo.svg" alt="" />
                        </div>
                        <div className='footer-descrip'>
                            <p>Artificial Intelligence refers to the simulation of human intelligence in machines programmed to mimic cognitive functions such as learning problem-solving, and decision-making. These systems are designed to analyse vast amounts of data, recognise patterns, and make predictions or decisions with minimal human intervention.</p>
                        </div>
                        <Box sx={{
                            display: "flex",
                            alignItems: "center"
                        }}>
                            <Link to="https://www.facebook.com/" target='_blank' rel="noopener noreferrer">
                                <div className='icon_footer'>
                                    <img className='facebook-1' src="../assets/images/red-facebook.svg" alt="" />
                                    <img className='facebook-2' src="../assets/images/white-facebook.svg" alt="" />
                                </div>
                            </Link>
                            <Link to="https://www.instagram.com/" target='_blank' rel="noopener noreferrer">
                                <div className='icon_footer'>
                                    <img className='insta-1' src="../assets/images/red-insta.svg" alt="" />
                                    <img className='insta-2' src="../assets/images/white-insta.svg" alt="" />
                                </div>
                            </Link>
                            <Link to="https://in.linkedin.com/" target='_blank' rel="noopener noreferrer">
                                <div className='icon_footer'>
                                    <img className='linkedin-1' src="../assets/images/red-linkedin.svg" alt="" />
                                    <img className='linkedin-2' src="../assets/images/white-linkedin.svg" alt="" />
                                </div>
                            </Link>
                            <Link to="https://x.com/i/flow/login" target='_blank' rel="noopener noreferrer">
                                <div className='icon_footer'>
                                    <img className='twitter-1' src="../assets/images/red-twitter.svg" alt="" />
                                    <img className='twitter-2' src="../assets/images/white-twitter.svg" alt="" />
                                </div>
                            </Link>
                        </Box>
                    </div>

                    <div className='according-area'>
                        <Accordion>
                            <Accordion.Item eventKey="0">
                                <Accordion.Header>Why IMUII</Accordion.Header>
                                <Accordion.Body>
                                    <div className='foorter-title'>
                                        <ul>
                                            <li>
                                                <Link to='/about' className='footer-text' >About Us</Link>
                                            </li>
                                            {/* <li>
                                                <Link to='/gdpr' className='footer-text' >GDPR</Link>
                                            </li> */}
                                            <li>
                                                <Link to='/career' className='footer-text' >Career</Link>
                                            </li>
                                            {/* <li>
                                                <Link to='/on-demand-developers' className='footer-text' >On Demand Developers</Link>
                                            </li> */}
                                            <li>
                                                <Link to='/contact' className='footer-text' >Contact Us</Link>
                                            </li>
                                        </ul>
                                    </div>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="1">
                                <Accordion.Header>Services</Accordion.Header>
                                <Accordion.Body>
                                    <div className='foorter-title'>
                                        <ul>
                                            <li>
                                                <Link to='/web-development' className='footer-text' >Web Development</Link>
                                            </li>
                                            <li>
                                                <Link to='/eCommerce-development' className='footer-text' >E-commerce Development</Link>
                                            </li>
                                            <li>
                                                <Link to='/mobile-application-development' className='footer-text' >Mobile Application Development</Link>
                                            </li>
                                            <li>
                                                <Link to='/saas-development' className='footer-text' >SAAS Development</Link>
                                            </li>
                                            <li>
                                                <Link to='/cybersecurity' className='footer-text' >Cybersecurity</Link>
                                            </li>
                                            
                                            <li>
                                                <Link to='/it-infrastructure' className='footer-text' >IT Infrastructure</Link>
                                            </li>
                                            <li>
                                                <Link to='/information-database-security' className='footer-text' >Information Database Security</Link>
                                            </li>
                                            <li>
                                                <Link to='/artificial-intelligence' className='footer-text' >Artificial Intelligence</Link>
                                            </li>
                                            <li>
                                                <Link to='/end-to-end' className='footer-text' >End-to-End Business Solutions</Link>
                                            </li>
                                        </ul>
                                    </div>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="2">
                                <Accordion.Header>Contact Us</Accordion.Header>
                                <Accordion.Body>
                                    <div className='foorter-title'>
                                        <div className='footer-address'>
                                            <p className='office-text'><strong>HEAD OFFICE :</strong> <br /> 616, Anna Salai, Thousand Lights, Chennai, Tamil Nadu 600006.</p>
                                            <p>Sales : +91 444 777 4011 <br /> Support : +91 444 777 4011</p>
                                        </div>
                                    </div>
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </div>
    
                </Box>
            </Container>
        </footer>

        <section className='copy-right'>
            <div className='copy-text'>
                <p>Copyright © 2025, Imuii Technology Private Limited. All Rights Reserved.</p>
            </div>
        </section>

        <div className='back-to-top' onClick={scrollToTop} style={{display: visible ? 'inline' : 'none'}}> 
            <img src="../assets/images/back-top.svg" alt="" />
        </div> 
    </>
  )
}
